<div class="main-container">
  <p-toast></p-toast>
  <div class="left-container">
    <table class="contact-table" *ngIf="contactRequestService.leadType.id == 1">
      <colgroup>
        <col class="left-table-first-col">
        <col class="left-table-second-col">
      </colgroup>
      <tr class="contact-list-item">
        <td>
          <strong>
            First name
          </strong>
        </td>
        <td>
          <!-- {{contactRequestService.contactRequest.firstName}} -->
        </td>
      </tr>
    <tr class="contact-list-item">
      <td>
        <strong>
          Family name
        </strong>
      </td>
      <td>
        <!-- {{contactRequestService.contactRequest.lastName}} -->
      </td>
    </tr>
    <tr  class="contact-list-item">
      <td>
        <strong>
          Message
        </strong>
      </td>
      <td colspan="2" class="contact-message-box">
        <!-- <div [innerHTML]="contactRequestService.contactRequest.message"></div> -->
    </td>
    </tr>
  </table>
    <table class="contact-table" *ngIf="contactRequestService.leadType.id == 2">
      <colgroup>
        <col class="left-table-first-col">
        <col class="left-table-second-col">
      </colgroup>
      <tr class="contact-list-item">
          <td>
              <strong>
                  First name
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.firstName}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Family name
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.lastName}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Language
              </strong>
          </td>
          <td>
            <!-- <p *ngIf="contactRequestService.quotationRequest.language">
              {{contactRequestService.quotationRequest.language.name}} -->
            <!-- </p> -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  City - Country
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.cityCountry}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Phone number
              </strong>
          </td>
          <td>
            <!-- {{contactRequestService.quotationRequest.phone}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Email
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.email}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Destination
              </strong>
          </td>
          <td>
              <!-- <p *ngIf="contactRequestService.quotationRequest.destination">
                {{contactRequestService.quotationRequest.destination.name}} -->
              <!-- </p> -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Programme
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.programme}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Accommodation
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.accommodationType.name}} -->
          </td>
      </tr>
      <tr>
          <td>
  
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.otherAccommodationType}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Room
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.roomType.name}} -->
          </td>
      </tr>
      <tr>
          <td>
  
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.otherRoomType}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Board
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.boardType.name}} -->
          </td>
      </tr>
      <tr>
          <td>
  
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.otherBoardType}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Insurance
              </strong>
          </td>
          <td>
              <!-- <p-checkbox binary="true" [readonly]="true" [(ngModel)]="contactRequestService.quotationRequest.needInsurance"></p-checkbox> -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Garantie Annulation
              </strong>
          </td>
          <td>
              <!-- <p-checkbox binary="true" [readonly]="true" [(ngModel)]="contactRequestService.quotationRequest.needGarantieAnnulation"></p-checkbox> -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Birthdate
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.birthDate}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Course intensity
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.courseType}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  Course option
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.courseOption}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  From
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.startDate}} -->
          </td>
      </tr>
      <tr class="contact-list-item">
          <td>
              <strong>
                  To
              </strong>
          </td>
          <td>
              <!-- {{contactRequestService.quotationRequest.endDate}} -->
          </td>
      </tr>
      <tr>
          <td class="contact-message-box-title">
              <strong>
                  Message
              </strong>
          </td>
      </tr>
      <tr>
          <td colspan="2" class="contact-message-box">
              <!-- <div [innerHTML]="contactRequestService.quotationRequest.comment"></div> -->
          </td>
      </tr>
  </table>
  <table class="contact-table" *ngIf="contactRequestService.leadType.id == 3">
    <colgroup>
      <col class="left-table-first-col">
      <col class="left-table-second-col">
    </colgroup>
    <tr class="contact-list-item">
      <td>
        <strong>
          First name
        </strong>
      </td>
      <td>
        {{contactRequestService.contactRequest!.firstName}}
      </td>
    </tr>
    <tr class="contact-list-item">
      <td>
        <strong>
          Family name
        </strong>
      </td>
      <td>
        {{contactRequestService.contactRequest!.lastName}}
      </td>
    </tr>
    <tr class="contact-list-item">
      <td>
        <strong>
          Message
        </strong>
      </td>
      <td colspan="2" class="contact-message-box">
        <div [innerHTML]="contactRequestService.contactRequest!.message"></div>
      </td>
    </tr>
  </table>
</div>
<div class="right-container">
  <div [formGroup]="quotationForm" class="booking-form" *ngIf="quotationForm">
    <div class="description-box">
      Description
      <input pInputText formControlName="description">
    </div>
    <div class="comment-box">
      Remarques
      <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
    </div>
    <div class="quotation-options-container">
      <div>
        <p>
          Base currency
        </p>
        <p-dropdown [options]="currencies" optionLabel="isoCode" formControlName="baseCurrency">
        </p-dropdown>
      </div>
      <div>
        <p>
          Second currency
        </p>
        <p-dropdown placeholder="--" [options]="currencies" optionLabel="isoCode" formControlName="secondCurrency">
        </p-dropdown>
      </div>
      <div>
        <p>
          Quotation date
        </p>
        <p-calendar [monthNavigator]="true" [yearRange]="yearRange" [yearNavigator]="true" formControlName="quotationDate"
          dateFormat="dd/mm/yy"></p-calendar>
      </div>
      <div>
        <p>
          Balance due date
        </p>
        <p-calendar [monthNavigator]="true" [yearRange]="yearRange" [yearNavigator]="true" formControlName="dueDate"
          dateFormat="dd/mm/yy"></p-calendar>
      </div>
      <div>
        <p>
          Deposit(EUR)
        </p>
        <input pInputText formControlName="deposit">
      </div>
    </div>
    <table class="transaction-table">
      <tr class="first-table-row">
        <th>#</th>
        <th>Type</th>
        <th class="description-th">Remarks</th>
        <th>Price</th>
        <th class="currency-th">Currency</th>
        <!-- Base currency -->
        <th>{{quotationForm.get('baseCurrency')!.value.isoCode}}</th>
        <!-- Second currency -->
        <th *ngIf="quotationForm.get('secondCurrency')!.value">
          {{quotationForm.get('secondCurrency')!.value.isoCode}}</th>
      </tr>
      <tr class="no-record-tr" *ngIf="productFormArray.length==0">
        <td colspan="6">
          <div class="no-record-row">
            <p class="no-record-message">
              No record
            </p>
            <div class="icon-wrap" (click)="insertItem(0)">
              <i class="pi pi-plus"></i>
            </div>
          </div>
        </td>
      </tr>
      <tr formArrayName="products" *ngFor="let product of productFormArray; let i = index"
        (mouseenter)="mouseover(i)" (mouseleave)="mouseout(i)">
        <td [formGroupName]="i">
          {{i + 1}}
        </td>
        <td [formGroupName]="i">
          <p-dropdown [options]="productTypes" formControlName="type" optionLabel="name">
            <ng-template pTemplate="item" let-item>
              {{item.label | titlecase}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item.label | titlecase}}
            </ng-template>
          </p-dropdown>
        </td>
        <td [formGroupName]="i" class="description-container">
          <textarea [rows]="1" pInputTextarea formControlName="description" [autoResize]="true" id="description-input"></textarea>
        </td>
        <td [formGroupName]="i">
          <input pInputText formControlName="amount" id="amount-input">
        </td>
        <td [formGroupName]="i">
          <p-dropdown [style]="{'minWidth':'50px'}" [options]="currencies" formControlName="currency" optionLabel="isoCode"></p-dropdown>
        </td>
        <td>
          {{productPriceInCurrency[i]}}
        </td>
        <td *ngIf="quotationForm.get('secondCurrency')!.value">
          {{productPriceInSecondCurrency[i]}}
        </td>
        <td class="menu-head">
          <table class="hover-menu" [hidden]="isHidden(i)">
            <tr>
              <td>
                <div class="icon-container">
                  <i class="pi pi-caret-up" (click)="moveUp(i)"></i>
                </div>
              </td>
              <td>
                <div class="icon-container">
                  <i class="pi pi-caret-down" (click)="moveDown(i)"></i>
                </div>
              </td>
              <td>
                <div class="icon-container">
                  <i class="pi pi-plus-circle" (click)="insertItem(i)"></i>
                </div>
              </td>
              <td>
                <div class="icon-container">
                  <i class="pi pi-times-circle" (click)="removeItem(i)"></i>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <div class="price-includes-container">
      <div>
        <p>
          Prices include
        </p>
        <ckeditor [editor]="Editor" formControlName="priceIncludes"></ckeditor>
      </div>
      <div>
        <p>
          Prices do not includes
        </p>
        <ckeditor [editor]="Editor" formControlName="priceNotIncludes"></ckeditor>
      </div>
    </div>
    <div class="submit-button-container">
      <p-button label="Submit" (onClick)="createQuotation()"></p-button>
      <p-button label="Save as template" (onClick)="activateTemplateSavingDialog()"></p-button>
      <p-button label="Load templates" (onClick)="getQuotationTemplates()"></p-button>
    </div>
   </div>
 </div>
 <p-dialog header="Select Template" [(visible)]="displayTemplateDialog" [modal]="true">
  <div class="template-dialog">
    <p-listbox  (onChange)="setFormValuesFromTemplate($event.value)" placeholder="SELECT" [options]="templates" optionLabel="name" [(ngModel)]="selectedTemplate"></p-listbox>
    <p *ngIf="templates.length==0">Template list is empty.</p>
  </div>
</p-dialog>
<p-dialog header="Save this quotation as template" [(visible)]="displayTemplateCreatingDialog" [modal]="true">
  <div class="template-dialog">
    <p>
      Input the name of template, then save.
    </p>
    <input pInputText [(ngModel)]="selectedTemplateName" class="template-name-input">
    <p-button label="Save" (onClick)="saveQuotationAsTemplate()"></p-button>
    </div>
</p-dialog>
